import { createContext } from 'react';

const activities = [];
const formFields = [];
const layout = [
    {
        width: 200,
        filterType: 'text',
        type: 'object',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Deal',
        filterValue: 'Deal',
        textValue: 'deal',
    },
    {
        width: 200,
        filterType: 'select',
        type: 'object',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Kategori',
        filterValue: 'ActivityType',
        textValue: 'activityType',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Titel',
        filterValue: 'Name',
        textValue: 'name',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Datum',
        filterValue: 'Date',
        textValue: 'date',
    },
    {
        width: 150,
        filterType: 'text',
        type: 'object',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Ägare',
        filterValue: 'Owner',
        textValue: 'owner',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'object',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Organisation',
        filterValue: 'Organization',
        textValue: 'organization',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'list',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Personer',
        filterValue: 'ActivityPersons',
        textValue: 'activityPersons',
    },
];

export const initialState = {
    apiUrl: 'crmActivityFront',
    layout: layout,
    activities: activities,
    rows: activities,
    activeActivity: null,
    formFields: formFields,
    isSavedToastOpen: false,
    isDeletedToastOpen: false,
    isErrorToastOpen: false,
    viewSettings: {
        minIndex: 0,
        maxIndex: 0,
        itemHeight: 40,
        totalHeight: 0,
        bufferHeight: 0,
        topPaddingHeight: 0,
        bottomPaddingHeight: 0,
        tolerance: 20,
    },
    requestObject: {
        startIndex: 0,
        amount: 30,
        tolerance: 20,
        filters: {},
    },
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_VIEW_SETTINGS_AND_REQUEST_OBJECT':
            return {
                ...state,
                viewSettings: action.viewSettings,
                requestObject: action.requestObject,
            };
        case 'UPDATE_VIEW_SETTINGS':
            return {
                ...state,
                viewSettings: action.viewSettings,
            };
        case 'UPDATE_REQUEST_OBJECT':
            return {
                ...state,
                requestObject: action.requestObject,
            };
        case 'UPDATE_DATA':
            return {
                ...state,
                activities: action.payload,
                rows: action.payload,
            };
        case 'UPDATE_ACTIVE_ACTIVITY':
            return {
                ...state,
                activeActivity: action.payload,
            };
        case 'UPDATE_ACTIVITIES_AND_ACTIVE_ACTIVITY':
            return {
                ...state,
                activities: action.activities,
                rows: action.activities,
                activeActivity: action.activeActivity,
            };
        case 'UPDATE_FORM_FIELDS':
            let tmpFormFields = formFields;
            tmpFormFields[action.index].fields = action.payload;
            return {
                ...state,
                formFields: tmpFormFields,
            };
        case 'SHOW_SAVED_TOAST':
            return {
                ...state,
                isSavedToastOpen: true,
            };
        case 'SHOW_DELETED_TOAST':
            return {
                ...state,
                isDeletedToastOpen: true,
            };
        case 'SHOW_ERROR_TOAST':
            return {
                ...state,
                isErrorToastOpen: true,
            };
        case 'CLOSE_SAVED_TOAST':
            return {
                ...state,
                isSavedToastOpen: false,
            };
        case 'CLOSE_DELETED_TOAST':
            return {
                ...state,
                isDeletedToastOpen: false,
            };
        case 'CLOSE_ERROR_TOAST':
            return {
                ...state,
                isErrorToastOpen: false,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
